var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SVG } from '../global';
export var CheckedCircle = function (props) {
    return (React.createElement(SVG, __assign({ testId: "checked-circle", width: "22", viewBox: "0 0 22 22" }, props),
        React.createElement("circle", { cx: "11", cy: "11", r: "11" }),
        React.createElement("g", { transform: "translate(5.665 5.915)" },
            React.createElement("path", { d: "M3.648-6.692,7.785-4.11l5.863-8.975", transform: "translate(-3.648 13.085)", fill: "none", stroke: "#fff", strokeWidth: "3" }))));
};
export var ErrorCircle = function (props) {
    return (React.createElement(SVG, __assign({ testId: "error-circle", width: "22", viewBox: "0 0 22 22" }, props),
        React.createElement("path", { d: "M241.259,11476.006a11,11,0,1,0,11,11A11,11,0,0,0,241.259,11476.006Zm1.181,17.4a1.6,1.6,0,0,1-1.172.416,1.642,1.642,0,0,1-1.19-.408,1.81,1.81,0,0,1-.009-2.311,1.671,1.671,0,0,1,1.2-.4,1.624,1.624,0,0,1,1.177.4,1.78,1.78,0,0,1,0,2.294Zm-.046-4.778h-2.234l-.467-8.439h3.168Z", transform: "translate(-230.259 -11476.006)" })));
};
export var WarningCircle = function (props) {
    return (React.createElement(SVG, __assign({ testId: "warning-circle", width: "22", viewBox: "0 0 22 22" }, props),
        React.createElement("path", { d: "M241.259,11476.006a11,11,0,1,0,11,11A11,11,0,0,0,241.259,11476.006Zm1.181,17.4a1.6,1.6,0,0,1-1.172.416,1.642,1.642,0,0,1-1.19-.408,1.81,1.81,0,0,1-.009-2.311,1.671,1.671,0,0,1,1.2-.4,1.624,1.624,0,0,1,1.177.4,1.78,1.78,0,0,1,0,2.294Zm-.046-4.778h-2.234l-.467-8.439h3.168Z", transform: "translate(-230.259 -11476.006)" })));
};
//# sourceMappingURL=circle.js.map